import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useI18n } from "../context/I18nContext";
import { toast } from "sonner";

export function ProductCard({ product }) {
  const { add } = useCart();
  const { t, lang } = useI18n();

  const onAdd = (e) => {
    e.preventDefault();
    add(product, 1);
    toast.success(t("product.added"));
  };

  return (
    <Link
      to={`/product/${product.id}`}
      className="product-card group bg-white border border-slate-200 flex flex-col h-full"
      data-testid={`product-card-${product.sku}`}
    >
      <div className="aspect-[4/3] overflow-hidden bg-slate-50 border-b border-slate-200">
        <img
          src={product.image_url}
          alt={lang === "ar" ? product.name_ar : product.name_en}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="p-4 flex-1 flex flex-col gap-2">
        <div className="label-mono text-slate-500">{product.sku}{product.brand ? ` · ${product.brand}` : ""}</div>
        <div className="font-display font-bold text-base leading-snug text-slate-900 line-clamp-2">
          {lang === "ar" ? product.name_ar : product.name_en}
        </div>
        <div className="mt-auto flex items-end justify-between pt-3">
          <div>
            <div className="font-display font-black text-xl text-[#8D1B3D]">
              {product.price.toFixed(2)} <span className="text-xs font-bold text-slate-500">{t("common.currency")}</span>
            </div>
            <div className="label-mono text-emerald-600">
              {product.stock > 0 ? t("shop.stock") : t("shop.out")}
            </div>
          </div>
          <button
            onClick={onAdd}
            className="btn-maroon px-3 py-2 text-xs font-bold tracking-wide"
            data-testid={`add-to-cart-${product.sku}`}
          >
            {t("shop.addToCart")}
          </button>
        </div>
      </div>
    </Link>
  );
}
